// src/pinball/components/TableSelector.tsx - Table theme selection screen

import React from 'react';
import { TableThemeConfig } from '../types';
import { ALL_TABLES } from '../tables';
import './TableSelector.css';

interface TableSelectorProps {
  onSelectTable: (table: TableThemeConfig) => void;
  onBack?: () => void;
}

export const TableSelector: React.FC<TableSelectorProps> = ({ onSelectTable, onBack }) => {
  return (
    <div className="table-selector" data-testid="table-selector">
      <div className="table-selector-header">
        {onBack && (
          <button className="table-selector-back" onClick={onBack}>
            ← Back
          </button>
        )}
        <h2>Select a Table</h2>
        <p>Choose your pinball adventure</p>
      </div>

      <div className="table-selector-grid">
        {ALL_TABLES.map((table) => (
          <div
            key={table.id}
            className="table-card"
            onClick={() => onSelectTable(table)}
            data-testid={`table-card-${table.id}`}
          >
            <div
              className="table-card-preview"
              style={{ backgroundColor: table.theme.playfieldColor }}
            >
              <div className="table-card-icon">🎯</div>
            </div>
            <div className="table-card-info">
              <h3>{table.name}</h3>
              <p>{table.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
